import { CommissionTypes } from 'constants/commissionTypes';

import { Identifier } from 'react-admin';
import { Commission } from 'types/embedded/commission';
import { getId } from 'utils';

export const getRelatedCommissionsLinkParams = (record?: Commission) => {
  if (!record) {
    return null;
  }

  switch (record?.typeEnum?.value) {
    case CommissionTypes.Child:
      return {
        pathname: '/commissions',
        search: `filter=${encodeURIComponent(JSON.stringify({ id: getId(record.parent?.['@id'] as Identifier) }))}`,
      };
    case CommissionTypes.Parent:
      return {
        pathname: '/commissions',
        search: `filter=${encodeURIComponent(JSON.stringify({ parent: record.originId }))}`,
      };
    default:
      return null;
  }
};
